import React from "react";
import Icon from "@mdi/react";
import {
  mdiTwitter,
  mdiInstagram,
  mdiMedium,
  mdiLinkedin,
  mdiDribbble,
  mdiYoutube,
  mdiVimeo
} from "@mdi/js";

const icons = {
  twitter: mdiTwitter,
  instagram: mdiInstagram,
  medium: mdiMedium,
  linkedin: mdiLinkedin,
  dribbble: mdiDribbble,
  youtube: mdiYoutube,
  vimeo: mdiVimeo
};

export default ({ icon, children, ...props }) => (
  <a className="social" {...props} target="_blank">
    {icon && (
      <Icon
        path={icons[icon]}
        size="24px"
        color="#696969"
        className="social_icon"
      />
    )}
  </a>
);
